var voted_users_rtlignore_default = {
  "container": "gidZC",
  "webview": "DipDa",
  "avatar_list": "Kswo-",
  "avatar": "tvcMH",
  "user_avatar": "FB3gJ",
  "modal": "JU7H3",
  "voted_users_modal": "WRi4I",
  "overlay": "p5aYK",
  "user_card": "yA3bP",
  "user_name": "Lz6Xm",
  "voted_users_modal_header": "_9pq-a",
  "cta": "zvrD3",
  "close_icon": "mPVZT",
  "title": "FfgZh",
  "member_list_container": "pbf38",
  "member_list": "B3WX4",
  "loader": "v8bBM",
  "anonymous_counter": "p0HmX",
  "spinner": "Db0oT",
  "spin": "_1WgOO"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
